module.exports = __webpack_public_path__ + "894a2ede85a483bf9bedefd4db45cdb9.ttf";